module.exports = __webpack_public_path__ + "static/img/IMG_20241027_170113_edit_757515846455717.2eca7845.jpg";